export enum VisitorRegistrationFormStatus {
    New = "new",
    Draft = "draft",
    Submitted = "submitted",
    InReview = "inReview",
    HRApproved = "hrApproved",
    EHSApproved = "ehsApproved",
    Approved = "approved",
    ApprovedForReview = "approvedForReview",
    HRApprovedForReview = "hrApprovedForReview",
    EHSApprovedForReview = "ehsApprovedForReview",
    Rejected = "rejected",
    Archived = "archived",
}
